import ReactMarkdown from "react-markdown";
import type { Components } from "react-markdown";
import { cn } from "lib/utils";

/** Markdown collapses single newlines; preserve them like whitespace-pre-wrap. */
function preserveSingleLineBreaks(content: string): string {
  return content.replace(/([^\n])\n(?!\n)/g, "$1  \n");
}

const knowledgeMarkdownComponents: Components = {
  p: ({ children }) => <p className="my-1 first:mt-0 last:mb-0">{children}</p>,
  br: () => <br />,
  strong: ({ children }) => (
    <strong className="font-semibold text-inherit">{children}</strong>
  ),
  em: ({ children }) => <em className="italic">{children}</em>,
  ul: ({ children }) => (
    <ul className="my-1 list-disc space-y-1 pl-5 first:mt-0 last:mb-0">
      {children}
    </ul>
  ),
  ol: ({ children }) => (
    <ol className="my-1 list-decimal space-y-1 pl-5 first:mt-0 last:mb-0">
      {children}
    </ol>
  ),
  li: ({ children }) => <li className="leading-relaxed">{children}</li>,
};

type KnowledgeMarkdownProps = {
  content: string;
  className?: string;
};

export function KnowledgeMarkdown({
  content,
  className,
}: KnowledgeMarkdownProps) {
  return (
    <div className={cn("break-words leading-relaxed", className)}>
      <ReactMarkdown components={knowledgeMarkdownComponents}>
        {preserveSingleLineBreaks(content)}
      </ReactMarkdown>
    </div>
  );
}
